import React from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import { ReactComponent as SearchIcon } from "../Assets/Icons/search.svg";
import FilterICon from "../Assets/Icons/filterIcon.svg";
import InfoIcon from "../Assets/Icons/info.svg";
import PeopleCard from "../Components/PeopleCard";
import PeopleAvatar from "../Assets/PeopleAvatar.png";
import PeopleAvatarOne from "../Assets/PeopleAvatar1.png";
import PeopleAvatarTwo from "../Assets/PeopleAvatar2.png";
import PeopleAvatarThree from "../Assets/PeopleAvatar3.png";
import PeopleAvatarFour from "../Assets/PeopleAvatar4.png";
import CloseIcon from "../Assets/Icons/crossIcon.svg";
import SearchPeopleDropDown from "../Components/SearchPeopleDropDown";

export default function SearchPeople() {
  return (
    <div>
      <DashboardLayout>
        <section className="bg-white pl-6 py-4 gap-y-5 w-full flex flex-col items-start">
          <Breadcrumbs links={[{ name: "Search People", link: "dsads" }]} />
          <h1 className="text-xl font-semibold">Search People</h1>
          <div className="flex items-center gap-4">
            <div className="flex items-center ">
              <div className="rounded-l-lg border flex items-center py-2 px-3 bg-[#F9FAFB] w-[23rem]">
                <SearchIcon />
                <input
                  type="text"
                  placeholder="Search for individual"
                  className="border-none ml-2 bg-inherit w-full text-sm font-medium text-[#6B7280] focus:outline-none"
                />
              </div>
              <div>
                <button className="w-[4.4rem] py-2 px-2 text-[0.95rem] font-[500] text-white rounded-r-lg bg-[#942A27]">
                  Search
                </button>
              </div>
            </div>
            {/* <div>
              <button className="w-[5.6rem] h-[2.3rem] flex items-center justify-center border-[1px] border-[#E5E7EB] rounded-[8px] gap-2">
                <img src={FilterICon} /> Filters
              </button>
            </div> */}
          </div>
        </section>
        <section className="bg-[#f9fafb] w-full pt-6 px-8 pb-6">
          {/* <div
            style={{
              boxShadow:
                "0px 10px 10px 0px rgba(0, 0, 0, 0.04), 0px 20px 25px -5px rgba(0, 0, 0, 0.10)",
            }}
            className="w-[37rem] pt-6 pb-6 border-[1px] border-[#E5E7EB] rounded-[8px] px-6"
          >
            <div className="flex items-center justify-between">
              <p className="[1.1rem] text-[#6B7280]">Filter</p>
              <img className="cursor-pointer" src={CloseIcon} />
            </div>
            <p className="text-[0.98rem] text-[#111928] font-[500] mt-4">
              Account type
            </p>
            <div className="flex items-center justify-center mt-2">
              <div className="w-[11.3rem] h-[2.4rem] border-[1px] border-[#E5E7EB] border-r-[0px] rounded-l-[8px] flex items-center">
                <div className="flex items-center gap-2 ml-2">
                  <input
                    name="all"
                    type="radio"
                    className="accent-[#942A27] w-[1rem] h-[1rem]"
                  />
                  <label
                    className="text-[0.94rem] text-[#111928] font-[500]"
                    name="all"
                  >
                    All
                  </label>
                </div>
              </div>
              <div className="w-[11.3rem] h-[2.4rem] border-[1px] border-[#E5E7EB] flex items-center">
                <div className="flex items-center gap-2 ml-2">
                  <input
                    name="all"
                    type="radio"
                    className="accent-[#942A27] w-[1rem] h-[1rem]"
                  />
                  <label
                    className="text-[0.94rem] text-[#111928] font-[500]"
                    name="all"
                  >
                    User
                  </label>
                </div>
              </div>
              <div className="w-[11.3rem] h-[2.4rem] border-[1px]  rounded-r-[8px]  border-[#E5E7EB] border-l-[0px] flex items-center">
                <div className="flex items-center gap-2 ml-2">
                  <input
                    name="all"
                    type="radio"
                    className="accent-[#942A27] w-[1rem] h-[1rem]"
                  />
                  <label
                    className="text-[0.94rem] text-[#111928] font-[500]"
                    name="all"
                  >
                    Company
                  </label>
                </div>
              </div>
            </div>
            <p className="text-[0.98rem] text-[#111928] font-[500] mt-4">
              Job title
            </p>
            <div>
              <div className="flex items-center flex-wrap gap-3 mt-3">
                <button className="w-[10.6rem] h-[2.2rem] text-[0.90rem] font-[500] text-[#942A27] rounded-[8px] border-[#942A27] border-[1px] font-[500] hover:bg-[#942A27] hover:text-white ">
                  Frontend developer
                </button>
                <button className="w-[10.6rem] h-[2.2rem] text-[0.90rem] font-[500] text-[#942A27] rounded-[8px] border-[#942A27] border-[1px] font-[500] hover:bg-[#942A27] hover:text-white ">
                   UI/UX Designer
                </button>
                <button className="w-[10.6rem] h-[2.2rem] text-[0.90rem] font-[500] text-[#942A27] rounded-[8px] border-[#942A27] border-[1px] font-[500] hover:bg-[#942A27] hover:text-white ">
                React Developer
                </button>
                <button className="w-[10.6rem] h-[2.2rem] text-[0.90rem] font-[500] text-[#942A27] rounded-[8px] border-[#942A27] border-[1px] font-[500] hover:bg-[#942A27] hover:text-white ">
                Php Developer
                </button>
                <button className="w-[10.6rem] h-[2.2rem] text-[0.90rem] font-[500] text-[#942A27] rounded-[8px] border-[#942A27] border-[1px] font-[500] hover:bg-[#942A27] hover:text-white ">
                Engineer
                </button>
                <button className="w-[10.6rem] h-[2.2rem] text-[0.90rem] font-[500] text-[#942A27] rounded-[8px] border-[#942A27] border-[1px] font-[500] hover:bg-[#942A27] hover:text-white ">
                Marketing
                </button>
              </div>
            </div>
            <div>
            <p className="text-[0.98rem] text-[#111928] font-[500] mt-4">
            Add property  
            </p>
            <div className="flex items-center flex-wrap gap-3 mt-3">
              <SearchPeopleDropDown text='Location' />
              <SearchPeopleDropDown text='Industry' />
              <SearchPeopleDropDown text='School' />
              <SearchPeopleDropDown text='Sector' />
              <SearchPeopleDropDown text='Looking for' />
              <SearchPeopleDropDown text='Company Name' />
              <SearchPeopleDropDown text='Technology' />
              <SearchPeopleDropDown text='Degree level' />
              <SearchPeopleDropDown text='Research Interest' />
              <SearchPeopleDropDown text='Program' /> 
              <SearchPeopleDropDown text='Expertise' /> 
              <SearchPeopleDropDown text='Experience Level' /> 
              </div>
            </div>
            <div className="flex items-center gap-2 mt-4">
              <button className="w-[9.5rem] h-[2.5rem] rounded-[8px] text-[0.90rem] text-white font-[500] bg-[#942A27]">Show 32 Results</button>
              <button className="w-[4.9rem] h-[2.5rem] rounded-[8px] border-[#E5E7EB] border-[1px] text-[#1F2A37] text-[0.90rem]">Reset</button> 
            </div>
          </div> */}
          <div>
            <p className="text-[1rem] font-bold text-[#6B7280]">
              All Users: <span className="text-[#111928]">1,356,546</span>
            </p>
          </div>
          <div className="flex items-center justify-center flex-wrap gap-7 mt-5">
            <PeopleCard
              img={PeopleAvatar}
              name="Roberta Casas"
              location="Data Scientist"
              company="Binford Ltd."
              teamname="Team name"
            />
            <PeopleCard
              img={PeopleAvatarOne}
              name="Roberta Casas"
              location="Data Scientist"
              company="Binford Ltd."
              teamname="Team name"
            />
            <PeopleCard
              img={PeopleAvatarTwo}
              name="Roberta Casas"
              location="Data Scientist"
              company="Binford Ltd."
              teamname="Team name"
            />
            <PeopleCard
              img={PeopleAvatarFour}
              name="Roberta Casas"
              location="Data Scientist"
              company="Binford Ltd."
              teamname="Team name"
            />
            <PeopleCard
              img={PeopleAvatarTwo}
              name="Roberta Casas"
              location="Data Scientist"
              company="Binford Ltd."
              teamname="Team name"
            />
            <PeopleCard
              img={PeopleAvatar}
              name="Roberta Casas"
              location="Data Scientist"
              company="Binford Ltd."
              teamname="Team name"
            />
            <PeopleCard
              img={PeopleAvatarThree}
              name="Roberta Casas"
              location="Data Scientist"
              company="Binford Ltd."
              teamname="Team name"
            />
            <PeopleCard
              img={PeopleAvatarTwo}
              name="Roberta Casas"
              location="Data Scientist"
              company="Binford Ltd."
              teamname="Team name"
            />
            <PeopleCard
              img={PeopleAvatar}
              name="Roberta Casas"
              location="Data Scientist"
              company="Binford Ltd."
              teamname="Team name"
            />
            <PeopleCard
              img={PeopleAvatarOne}
              name="Roberta Casas"
              location="Data Scientist"
              company="Binford Ltd."
              teamname="Team name"
            />
            <PeopleCard
              img={PeopleAvatarThree}
              name="Roberta Casas"
              location="Data Scientist"
              company="Binford Ltd."
              teamname="Team name"
            />
            <PeopleCard
              img={PeopleAvatarFour}
              name="Roberta Casas"
              location="Data Scientist"
              company="Binford Ltd."
              teamname="Team name"
            />
          </div>
          <div className="flex items-center justify-center mt-8">
            <button className="w-[6.9rem] py-2 border-[1px] border-[#E5E7EB] rounded-[8px] text-[0.95rem] font-[500] text-[#1F2A37]">
              Load more
            </button>
          </div>
        </section>
      </DashboardLayout>
    </div>
  );
}
